export const SuggestionType = {
  Accessory: 'accessory',
  Color: 'color',
  Proportion: 'proportion',
  Styling: 'styling',
  Alternative: 'alternative',
} as const;
export type SuggestionType = typeof SuggestionType[keyof typeof SuggestionType];

export const SuggestionPriority = {
  High: 'high',
  Medium: 'medium',
  Low: 'low',
} as const;
export type SuggestionPriority = typeof SuggestionPriority[keyof typeof SuggestionPriority];

export const MobileTab = {
  Character: 'character',
  Preview: 'preview',
  Wardrobe: 'wardrobe',
} as const;
export type MobileTab = typeof MobileTab[keyof typeof MobileTab];

export const SelectionType = {
  Style: 'style',
  Pose: 'pose',
  Background: 'background',
  Hairstyle: 'hairstyle',
  HairColor: 'hairColor',
  Wardrobe: 'wardrobe',
  Retouch: 'retouch',
} as const;
export type SelectionType = typeof SelectionType[keyof typeof SelectionType];

export const ViewMode = {
  Standard: 'standard',
  Compare: 'compare',
  Grid: 'grid',
} as const;
export type ViewMode = typeof ViewMode[keyof typeof ViewMode];

export const Gender = {
  Female: 'female',
  Male: 'male',
} as const;
export type Gender = typeof Gender[keyof typeof Gender];

export const WardrobeCategory = {
  CompleteOutfits: 'complete-outfits',
  Outerwear: 'outerwear',
  Tops: 'tops',
  Bottoms: 'bottoms',
  Shoes: 'shoes',
  Glasses: 'glasses',
  Bags: 'bags',
  Hats: 'hats',
  Accessories: 'accessories',
} as const;
export type WardrobeCategory = typeof WardrobeCategory[keyof typeof WardrobeCategory];

export const TrendType = {
  Current: 'current',
  Classic: 'classic',
  Retro: 'retro',
  AvantGarde: 'avant-garde',
} as const;
export type TrendType = typeof TrendType[keyof typeof TrendType];

export const StatusType = {
  Good: 'good',
  Fair: 'fair',
  Poor: 'poor',
  Clean: 'clean',
  Visible: 'visible',
  Problematic: 'problematic',
} as const;
export type StatusType = typeof StatusType[keyof typeof StatusType];

export const CompletenessStatus = {
  Complete: 'complete',
  NeedsAccessory: 'needs-accessory',
  NeedsLayer: 'needs-layer',
  Minimal: 'minimal',
} as const;
export type CompletenessStatus = typeof CompletenessStatus[keyof typeof CompletenessStatus];

export const PresetCardSize = {
  Small: 'small',
  Medium: 'medium',
  Large: 'large',
} as const;
export type PresetCardSize = typeof PresetCardSize[keyof typeof PresetCardSize];

export const QualityTab = {
  Fashion: 'fashion',
  Technical: 'technical',
} as const;
export type QualityTab = typeof QualityTab[keyof typeof QualityTab];

export const EmptyStateVariant = {
  Default: 'default',
  Upload: 'upload',
  Pending: 'pending',
  Error: 'error',
  Success: 'success',
} as const;
export type EmptyStateVariant = typeof EmptyStateVariant[keyof typeof EmptyStateVariant];

export const ImageFit = {
  Contain: 'contain',
  Cover: 'cover',
} as const;
export type ImageFit = typeof ImageFit[keyof typeof ImageFit];

export const HairColor = {
  Natural: 'Natural',
  RavenBlack: 'Raven Black',
  DarkBrown: 'Dark Brown',
  Chestnut: 'Chestnut',
  Auburn: 'Auburn',
  Copper: 'Copper',
  HoneyBlonde: 'Honey Blonde',
  GoldenBlonde: 'Golden Blonde',
  Platinum: 'Platinum',
  StrawberryBlonde: 'Strawberry Blonde',
  Burgundy: 'Burgundy',
  Silver: 'Silver',
  Charcoal: 'Charcoal',
  PastelPink: 'Pastel Pink',
} as const;
export type HairColor = typeof HairColor[keyof typeof HairColor];
